import { SVGProps, Ref, forwardRef } from 'react';

export const CheckCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1m5.773 8L16.5 7.727l-6 6-3-3L6.227 12l4.273 4.273z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CheckCircleFilledSize24Glyph.displayName = 'CheckCircleFilledSize24Glyph';
